import { CompositeScreenProps } from '@react-navigation/native'
import { useTheme } from 'contexts'
import React, { useState } from 'react'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import { ProgramActionRow } from 'pages/Program/subcomponents/ProgramActionRow'

import { NavMenuButton } from 'partials/MobileNav/types'
import { Page } from 'partials/Page'

import { Box } from 'widgets/Box'
import { FlatList } from 'widgets/FlatList'

import { useNavigateBackOrHome } from 'hooks/useNavigateBackOrHome'
import { useCurrentUserWorkouts } from 'hooks/usePosts'

import { Post } from 'types/post'

export const ActionsListPage = ({ route, navigation }: CompositeScreenProps<any, any>) => {
  const onAdd = route?.params?.onAdd

  const theme = useTheme()
  const insets = useSafeAreaInsets()
  const navigateBackOrHome = useNavigateBackOrHome()

  const [selectedIds, setSelectedIds] = useState<string[]>([])

  const { data: workouts, isLoading } = useCurrentUserWorkouts()

  const handleAdd = () => {
    selectedIds.length && onAdd && onAdd(selectedIds)
    navigateBackOrHome()
  }

  const addMenuButton: NavMenuButton = {
    title: 'Add',
    titleColor: selectedIds.length ? 'v2primary' : 'grey',
    onPress: handleAdd,
  }

  const toggleSelect = (id: string) => {
    if (selectedIds.includes(id)) {
      const filteredIds = selectedIds.filter((sid) => sid !== id)
      setSelectedIds(filteredIds)
    } else {
      setSelectedIds([...selectedIds, id])
    }
  }

  return (
    <Page
      withBack
      withNav
      isLoading={isLoading}
      navigation={navigation}
      title='Your Workouts'
      backgroundColor='white'
      navbarRightButtons={[addMenuButton]}
    >
      <Box flex={1}>
        <FlatList<Post>
          keyExtractor={(p) => p.id}
          data={workouts}
          contentContainerStyle={{ paddingTop: theme.spacing.smd, paddingBottom: insets.bottom }}
          renderItem={({ item }) => {
            return (
              <ProgramActionRow
                data={item}
                isActionPicker
                isSelected={selectedIds.includes(item.id)}
                onActionPress={() => toggleSelect(item.id)}
              />
            )
          }}
        />
      </Box>
    </Page>
  )
}
